<script setup lang="ts">
onMounted(() => {
    useHead({
      script: [{
            src: "https://bauernhofurlaub.info/ratingswidget.js?id=65859",
            defer: true
      }]
    })
});
</script>

<template>
    <ClientOnly>
        <div class="flex justify-center mt-15">
            <a id="dz-rating-widget-65859" href="https://bauernhofurlaub.info/ferien-bauernhof/agriturismo-casa-bivignano-toskana?utm_source=Rating-Widget#Bewertungen" class="dzrw0" target="_blank">
              {{ $t('bauernhofurlaub.widget.text') }}
            </a>
        </div>
    </ClientOnly>
</template>